import { render, staticRenderFns } from "./menuComponent.vue?vue&type=template&id=0184e598&scoped=true&"
import script from "./menuComponent.vue?vue&type=script&lang=js&"
export * from "./menuComponent.vue?vue&type=script&lang=js&"
import style0 from "./menuComponent.vue?vue&type=style&index=0&id=0184e598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0184e598",
  null
  
)

export default component.exports